export const adaptRegionPayload = (
	data: RegionFormValues
): Record<string, unknown> => {
	// Manager id is the MeeUser GUID (string) on the .NET backend; do not
	// coerce to Number — that would yield NaN and serialise as null.
	return {
		name: data.name,
		region_manager: data.regionManager ? data.regionManager : null
	};
};
